import { render, staticRenderFns } from "./OrderHystory.vue?vue&type=template&id=3cd48654&scoped=true&"
import script from "./OrderHystory.vue?vue&type=script&lang=js&"
export * from "./OrderHystory.vue?vue&type=script&lang=js&"
import style0 from "./OrderHystory.vue?vue&type=style&index=0&id=3cd48654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd48654",
  null
  
)

export default component.exports